import './map.less';

// trim-below
import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

const b = block('map');

const GoogleMap = () => {
	return (
		<div className={b()}>
			<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d813.7414488574652!2d25.135153932723604!3d35.331670861551075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x149a598733663d93%3A0xc82fc17645a889ee!2zzqPOms6fzqXOoc6RzqMgzpzOlc6kzpHOm86bzpnOms6RIM6azqTOmc6hzpnOkQ!5e0!3m2!1sru!2sgr!4v1542310834851" width="100%" height="100%"></iframe>
		</div>
	);
}

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/components/map/index.jsx